import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from './store';
import { RouteCardTemplateReference } from '../interfaces';
import { getRouteCardTemplates } from '../api/getRouteCardTemplates';

export interface RouteCardTemplatesState {
    items: RouteCardTemplateReference[] | null;
}

const initialState: RouteCardTemplatesState = {
    items: null,
};

export const loadRouteCardTemplates = createAsyncThunk('routeCardTemplates/load', async () => {
    return await getRouteCardTemplates();
});

export const RouteCardTemplatesSlice = createSlice({
    name: 'routeCardTemplates',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadRouteCardTemplates.fulfilled, (state, action) => {
                state.items = action.payload;
            })
            .addCase(loadRouteCardTemplates.rejected, (state, action) => {
                console.error(action.error);
            });
    },
});

export const selectRouteCardTemplates = (state: RootState) => state.routeCardTemplates.items;

export default RouteCardTemplatesSlice.reducer;
